<template>
  <div class="qaqc-summary-cards">
    <div class="qaqc-summary-card">
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ totalTestsDisplay }}</span>
          <span v-if="badgePart(stats.totalTestsChange)" class="qaqc-summary-card-badge">{{ badgePart(stats.totalTestsChange) }}</span>
          <span class="qaqc-summary-card-meta" v-if="metaPart(stats.totalTestsChange)">{{ metaPart(stats.totalTestsChange) }}</span>
        </div>
        <div class="qaqc-summary-card-label-row">
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon qaqc-summary-card-info"
                width="16"
                height="16"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.totalTests }}</div>
          </v-tooltip>
          <span class="qaqc-summary-card-label">Total Tests</span>
        </div>
      </div>
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['file-outline']" contain class="qaqc-summary-card-icon-img" />
      </div>
    </div>
    <div class="qaqc-summary-card">
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ stats.cceTests }}</span>
        </div>
        <div class="qaqc-summary-card-label-row">
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon qaqc-summary-card-info"
                width="16"
                height="16"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.cceTests }}</div>
          </v-tooltip>
          <span class="qaqc-summary-card-label">Constant Composition Expansion Tests</span>
        </div>
      </div>
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['chart-line-cce']" contain class="qaqc-summary-card-icon-img" />
      </div>
    </div>
    <div class="qaqc-summary-card">
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ stats.dlTests }}</span>
        </div>
        <div class="qaqc-summary-card-label-row">
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon qaqc-summary-card-info"
                width="16"
                height="16"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.dlTests }}</div>
          </v-tooltip>
          <span class="qaqc-summary-card-label">Differential Liberation Tests</span>
        </div>
      </div>
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['chart-line-dl']" contain class="qaqc-summary-card-icon-img" />
      </div>
    </div>
    <div class="qaqc-summary-card">
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ stats.separatorTests }}</span>
        </div>
        <div class="qaqc-summary-card-label-row">
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon qaqc-summary-card-info"
                width="16"
                height="16"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.separatorTests }}</div>
          </v-tooltip>
          <span class="qaqc-summary-card-label">Separator Tests</span>
        </div>
      </div>
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['chart-line-dl']" contain class="qaqc-summary-card-icon-img" />
      </div>
    </div>
    <div class="qaqc-summary-card qaqc-summary-card-pass">
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ stats.passRate }}</span>
        </div>
        <div class="qaqc-summary-card-label-row">
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon qaqc-summary-card-info"
                width="16"
                height="16"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.passRate }}</div>
          </v-tooltip>
          <span class="qaqc-summary-card-label">Pass Rate</span>
        </div>
      </div>
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['check-pass']" contain class="qaqc-summary-card-icon-img" />
      </div>
    </div>
  </div>
</template>

<script>
import { OVERVIEW_SUMMARY_NOTES } from "./overviewDashboardNotes.js";

export default {
  name: "SummaryCards",
  data() {
    return {
      notes: OVERVIEW_SUMMARY_NOTES,
      infoIcon: require("@/assets/Svg/infoIcon.svg"),
      icons: {
        "file-outline": require("@/assets/Svg/file-outline.svg"),
        "chart-line-cce": require("@/assets/Svg/chart-line-cce.svg"),
        "chart-line-dl": require("@/assets/Svg/chart-line-dl.svg"),
        "check-pass": require("@/assets/Svg/check-pass.svg"),
      },
    };
  },
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        totalTests: 0,
        totalTestsChange: "",
        cceTests: 0,
        cceTestsPercent: "",
        dlTests: 0,
        dlTestsPercent: "",
        separatorTests: 0,
        separatorTestsPercent: "",
        passRate: "0%",
      }),
    },
  },
  computed: {
    totalTestsDisplay() {
      const fromApi = this.parseStatNum(this.stats.totalTests);
      if (fromApi !== null) return fromApi;
      const c = this.parseStatNum(this.stats.cceTests);
      const g = this.parseStatNum(this.stats.gasCceTests);
      const d = this.parseStatNum(this.stats.dlTests);
      const s = this.parseStatNum(this.stats.separatorTests);
      if (c === null && d === null) return this.stats.totalTests;
      return (c || 0) + (g || 0) + (d || 0) + (s || 0);
    },
  },
  methods: {
    parseStatNum(v) {
      if (v == null || v === "") return null;
      const n = Number(String(v).replace(/,/g, ""));
      return Number.isFinite(n) ? n : null;
    },
    badgePart(s) {
      if (!s) return "";
      const m = String(s).match(/^([+-]?\d+(?:\.\d+)?%?)/);
      return m ? m[1] : "";
    },
    metaPart(s) {
      if (!s) return "";
      const rest = String(s).replace(/^[+-]?\d+(?:\.\d+)?%?\s*/, "").trim();
      return rest;
    },
  },
};
</script>
